// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1XBvd","alert":"SettungsInbox_alert__1utgb"};